import type { Spacing, SpacingInput } from "../types/template";

export const ZERO_SPACING: Spacing = Object.freeze({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

export function normalizeSpacing(input?: SpacingInput): Spacing {
  if (input === undefined) {
    return { ...ZERO_SPACING };
  }

  if (typeof input === "number") {
    return {
      top: input,
      right: input,
      bottom: input,
      left: input,
    };
  }

  return {
    top: input.top ?? 0,
    right: input.right ?? 0,
    bottom: input.bottom ?? 0,
    left: input.left ?? 0,
  };
}

export function assertNonNegativeSpacing(
  spacing: Spacing,
  path: string,
  issues: string[],
): void {
  if (
    spacing.top < 0 ||
    spacing.right < 0 ||
    spacing.bottom < 0 ||
    spacing.left < 0
  ) {
    issues.push(`${path} must be non-negative.`);
  }
}
